<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de contenido</option>
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los tipos de contenidos</option>
        <option v-for="(contenido,index) in contenidos" :value="contenido.ContenidoDeIntreanetId" :key="index">{{contenido.TextoDelContenido}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        contenidos: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      textoDeSeleccion: {
        type: String,
        default: 'contenidos'
      }
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SICPO_Catalogos_establecer025ContenidosDeIntranet", parametros);
    },
    methods: {
      cargarContenidos: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SICPO.catalogos.C025ContenidosDeIntranet, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.contenidos = respuesta.data.ContenidosDeIntranet;
              this.$emit("terminoCargaDeContenidos", respuesta.data.ContenidosDeIntranet);
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        let tipoContenidoObj = this.obtenerTipoContenidoObj(evento.target.value);
        this.$store.dispatch("A_SICPO_Catalogos_establecer025ContenidosDeIntranet", parametros);
        this.$emit("valorParaElPadre", evento,tipoContenidoObj);
      },
      obtenerTipoContenidoObj: function(contenidoId) {
        let id = parseInt(contenidoId);
        let contenido = this.contenidos.find(cBD => cBD.ContenidoDeIntreanetId == id);
        return contenido;
      }
    },
    created() {
      this.cargarContenidos();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C025ContenidosDeIntranet.vue